function createSubscriptionApi(fieldSubscribers, formSubscribers, formMetaSubscribers) {
  const subscriptionApi = {
    subscribeToField: (fieldName, subscriber) => {
      const subscription = [fieldName, subscriber];
      fieldSubscribers.add(subscription);
      return () => {
        fieldSubscribers.delete(subscription);
      };
    },
    subscribeToForm: (subscriber) => {
      formSubscribers.add(subscriber);
      return () => {
        formSubscribers.delete(subscriber);
      };
    },
    subscribeToMeta: (subscriber) => {
      formMetaSubscribers.add(subscriber);
      return () => {
        formMetaSubscribers.delete(subscriber);
      };
    },
    removeAllListeners: () => {
      formSubscribers.clear();
      fieldSubscribers.clear();
      formMetaSubscribers.clear();
    }
  };
  return subscriptionApi;
}
export {
  createSubscriptionApi
};
//# sourceMappingURL=createSubscriptionApi.js.map
